<template>
  <div class="top-margin">
    <form v-on:submit.prevent>
      <img src="/beamylogo_white.svg" />
      <h2>Choose Site:</h2>
      <div class="error" v-if="errors && errors.all">{{ errors.all }}</div>

      <div :key="site" v-for="site in sites">
        <button @click="choose(site)" type="button" class="full-width title">{{ site }}</button>
      </div>

      <a class="other" @click="signOut">Sign out</a>
    </form>
  </div>
</template>

<script>
export default {
  name: "ChooseStore",
  data() {
    return {
      errors: {},
      sites: []
    }
  },
  async created() {
    const siteJson = await window.localStorage.getItem("sites");
    this.sites = JSON.parse(siteJson);
    if (this.sites.length == 1) {
      this.choose(this.sites[0]);
    }
  },
  methods: {
    choose(site) {
      window.localStorage.setItem("site", site);
      this.$router.push('/chooseStation')
    },
    signOut() {
      this.$router.push('/')
    }
  }
}
</script>

<style scoped lang="scss">
form {
  border-radius: 0.5rem;
  max-width: 400px;
  padding: 2rem;
  margin: 0px auto;
  margin-top: 1rem;
  background-color: var(--secondary-colour);
  font-size: 1em;

  .title { text-transform: capitalize; }
  img { width: 100%; }
  a { color: var(--text-colour); text-decoration: none; cursor: pointer; }

  button {
    margin-bottom: 1rem;
    margin-left: 0px !important;
    padding: 1rem;
    font-weight: bold;
    border-radius: 0.25rem;
    background-color: var(--action-colour);
    color: var(--primary-colour);
    border: none;
  }
}
</style>
